import axios from 'axios';

export async function HandleAddRemark(empID, dsc, coverings, row, setIsAdding, dispatch) {
    async function AddRemark(empID, dsc) {
        const url = 'api/covering/createRemark/';
        const body = { empID, dsc };

        let res = await axios.post(url, body).then(
            (response) => {
                if (response.data.success) {
                    row['remarks'] = response.data.remarks;
                    dispatch({
                        type: 'UPDATE_REMARKS_COVERINGS',
                        payload: coverings,
                    });
                    setIsAdding(false);
                    return { error: null };
                } else {
                    setIsAdding(false);
                    return { error: response.data.message };
                }
            },
            (error) => {
                setIsAdding(false);
                return { error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.' };
            }
        );

        return res;
    }

    return await AddRemark(empID, dsc);
}

export async function HandleEditRemark(empID, remID, dsc, coverings, row, setIsEditing, dispatch) {
    async function EditRemark() {
        const url = 'api/covering/adjustRemark/';
        const body = { empID, remID, dsc };

        let res = await axios.post(url, body).then(
            (response) => {
                if (response.data.success) {
                    row['remarks'] = response.data.remarks;
                    dispatch({
                        type: 'UPDATE_REMARKS_COVERINGS',
                        payload: coverings,
                    });
                    setIsEditing(false);
                    return { error: null };
                } else {
                    setIsEditing(false);
                    return { error: response.data.message };
                }
            },
            (error) => {
                setIsEditing(false);
                return { error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.' };
            }
        );

        return res;
    }

    return await EditRemark();
}

export async function HandleDeleteRemark(empID, remID, coverings, row, setIsDeleting) {
    async function DeleteRemark() {
        const url = 'api/covering/deleteRemark/';
        const body = { empID, remID };

        let res = await axios.post(url, body).then(
            (response) => {
                if (response.data.success) {
                    row['remarks'] = response.data.remarks;
                    setIsDeleting(false);
                    return { coverings: coverings, error: null };
                } else {
                    setIsDeleting(false);
                    return { coverings: null, error: response.data.message };
                }
            },
            (error) => {
                setIsDeleting(false);
                return { coverings: null, error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.' };
            }
        );

        return res;
    }

    return await DeleteRemark();
}
